import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import * as educationApi from "../../../api/educationApi/tutorApi";
import SubTitle from "../../../components/SubTitle";
import {useGetItemQuery, useUpdateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";
import {EDTutor, initializeTutor} from "../../../models/serverModels/education/EDTutor";
import TutorForm from "../tutor/TutorForm";

import * as Params from "../../../models/clientModels/interfaces/apiParams";

import {yupResolver} from "@hookform/resolvers/yup";
import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import * as tutorApi from "../../../api/educationApi/tutorApi";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import MWProgress from "../../../components/MWProgress";
import {FormSection} from "../../../styledComponents/StyledCreateForm";
import {tutorSchema} from "../../../validation/toturSchema";

const UpdateTutor = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: tutor, isLoading: isGetLoading} = useGetItemQuery<ResponseItem<EDTutor>>({
    key: ["Tutor", id],
    api: () => educationApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EDTutor>,
    Params.Update<EDTutor>
  >({
    api: tutorApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Education/TutorList");
        queryClient.invalidateQueries("TutorList");
      },
    },
  });

  const methods = useForm<EDTutor>({
    defaultValues: tutor?.item || initializeTutor,
    resolver: yupResolver(tutorSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(tutor?.item);
  }, [tutor?.item, reset]);

  const onSubmit: SubmitHandler<EDTutor> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeTutor, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="감사 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <TutorForm captionColor="#546E7A" />
            <ConfirmButtonGroup link="/Education/TutorList" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateTutor;
